import React, { useEffect, useState } from 'react';
import api from '../utils/api';

// «Мой день» — ежедневные привычки с отметкой в сайдбаре
const localDay = (offset = 0) => {
  const d = new Date(); d.setDate(d.getDate() - offset);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export default function HabitsWidget({ open, onToggleOpen, onOpenStats }) {
  const [data, setData] = useState(null);
  const [day, setDay] = useState(localDay());

  const load = () => {
    const d = localDay();
    setDay(d);
    api.get('/habits', { params: { day: d } }).then(r => setData(r.data)).catch(() => {});
  };

  useEffect(() => {
    load();
    const iv = setInterval(() => { if (localDay() !== day) load(); }, 60000); // смена суток
    return () => clearInterval(iv);
  }, [day]);

  if (!data) return null;
  const total = data.habits.length;
  const doneSet = new Set(data.done);
  const count = data.habits.filter(h => doneSet.has(h.key)).length;

  const toggle = (key) => {
    const next = !doneSet.has(key);
    const done = next ? [...data.done, key] : data.done.filter(k => k !== key);
    setData({ ...data, done, week: { ...data.week, [day]: done.length } });
    api.post('/habits/toggle', { day, habit: key, done: next }).catch(load);
  };

  const dots = [6, 5, 4, 3, 2, 1, 0].map(i => {
    const d = localDay(i);
    const n = d === day ? count : (data.week[d] || 0);
    return { d, ratio: n / total };
  });
  const dotColor = r => r >= 1 ? '#16a34a' : r >= 0.7 ? '#86efac' : r > 0 ? '#fde68a' : '#e2e8f0';

  return (
    <div style={{ margin: '4px 8px 6px', border: '1px solid #e2e8f0', borderRadius: 8, background: count === total ? '#f0fdf4' : '#fafbfc' }}>
      <button onClick={onToggleOpen} style={headStyle}>
        <span style={{ flex: 1, textAlign: 'left' }}>Мой день</span>
        <span style={{ color: count === total ? '#16a34a' : '#4f6ef7', fontWeight: 700, marginRight: 6 }}>{count}/{total}</span>
        <span style={{ fontSize: 9, transform: open ? 'rotate(90deg)' : 'none', transition: 'transform 0.15s' }}>▶</span>
      </button>
      {open && (
        <div style={{ padding: '0 8px 8px' }}>
          {data.habits.map(h => {
            const on = doneSet.has(h.key);
            return (
              <label key={h.key} style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '3px 2px', fontSize: 12, cursor: 'pointer', color: on ? '#94a3b8' : '#1e2a3a', textDecoration: on ? 'line-through' : 'none' }}>
                <input type="checkbox" checked={on} onChange={() => toggle(h.key)} style={{ accentColor: '#16a34a', margin: 0 }} />
                <span>
                  {h.label}
                  {h.intent && <span style={{ display: 'block', fontSize: 11, fontStyle: 'italic', color: '#16a34a', textDecoration: 'none' }}>«{h.intent}»</span>}
                </span>
              </label>
            );
          })}
          <div onClick={onOpenStats} style={{ display: 'flex', gap: 4, marginTop: 6, alignItems: 'center', cursor: 'pointer' }} title="Последние 7 дней — открыть аналитику">
            {dots.map(x => (
              <span key={x.d} title={x.d.split('-').reverse().join('.') + ': ' + Math.round(x.ratio * 100) + '%'}
                style={{ flex: 1, height: 6, borderRadius: 3, background: dotColor(x.ratio) }} />
            ))}
          </div>
          <button onClick={onOpenStats} style={{ marginTop: 6, background: 'none', border: 'none', padding: 0, color: '#4f6ef7', fontSize: 11, cursor: 'pointer' }}>Аналитика →</button>
        </div>
      )}
    </div>
  );
}

const headStyle = {
  display: 'flex', alignItems: 'center', width: '100%', fontSize: 10, fontWeight: 600,
  letterSpacing: '0.07em', textTransform: 'uppercase', color: '#8fa0b4',
  padding: '8px 10px', background: 'none', border: 'none', cursor: 'pointer',
};
